export const standardPermissions = {
  read: true,
  edit: true,
  create: true,
  delete: true,
};
